import React, { useContext, useEffect } from 'react';
import cn from 'classnames';
import { BaseModalContext } from '../../../../base-modal/esm';
import { ButtonMobile } from '../../../../button/esm/mobile';
import { getDataTestId } from '../../../../shared/esm';

var styles = {"footer":"select__footer_3nn6z","button":"select__button_3nn6z","highlighted":"select__highlighted_3nn6z"};
require('./index.css');

var Footer = function (_a) {
    var _b;
    var handleApply = _a.handleApply, handleClear = _a.handleClear, showClear = _a.showClear, _c = _a.clearText, clearText = _c === void 0 ? 'Сбросить' : _c, _d = _a.applyText, applyText = _d === void 0 ? 'Применить' : _d, dataTestId = _a.dataTestId;
    var _e = useContext(BaseModalContext), footerHighlighted = _e.footerHighlighted, setHasFooter = _e.setHasFooter;
    useEffect(function () {
        setHasFooter(true);
    }, [setHasFooter]);
    return (React.createElement("div", { 
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: 0, className: cn(styles.footer, (_b = {},
            _b[styles.highlighted] = footerHighlighted,
            _b)) },
        showClear && (React.createElement(ButtonMobile, { size: 'm', view: 'secondary', className: styles.button, onClick: handleClear, dataTestId: getDataTestId(dataTestId, 'clear') }, clearText)),
        React.createElement(ButtonMobile, { size: 'm', view: 'primary', className: styles.button, onClick: handleApply, dataTestId: getDataTestId(dataTestId, 'apply') }, applyText)));
};

export { Footer };
